// Custom hook.
import { useEffect } from 'react';
// -----------------------------------------------------------------------------
export const useOnEscKey = (callback) => {
    // Effect
    // ---------------------------------------------------------------------------
    useEffect(() => {
        const handleOnEsc = (event) => {
            if (event.key === 'Escape') {
                event.preventDefault();
                callback();
            }
        };
        document.addEventListener('keydown', handleOnEsc);
        return () => {
            document.removeEventListener('keydown', handleOnEsc);
        };
    }, [callback]);
};
//# sourceMappingURL=useOnEscKey.js.map